import type { Market } from '@backmarket/http-api'

import { DEFAULT_MARKET, MARKETS } from '../config'

/** Get market from domain string. Returns default if no match. */
export function getMarketFromDomain(domain: string): Market {
  const normalizedDomain = domain.replace(/:[0-9]+$/, '')

  const market = Object.values(MARKETS).find((m) => {
    return normalizedDomain.endsWith(m.domain)
  })

  return market ?? DEFAULT_MARKET
}
